module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.arvoreProjetos), function(projeto) {
    return _c('div', {
      staticClass: "tree-collapsed",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "tree-branch-head fa fa-plus-square",
      staticStyle: {
        "margin-right": "0.2em"
      },
      on: {
        "click": function($event) {
          return _vm.mostraFilhos(projeto)
        }
      }
    }), _vm._v(" "), _c('span', {
      class: _vm.projetoSelecionado.projectNumber === projeto.projectNumber ? 'tree-selected' : '',
      on: {
        "click": function($event) {
          return _vm.selecionaPai(projeto)
        }
      }
    }, [_vm._v("\n        " + _vm._s(projeto.projectNumber) + " - " + _vm._s(projeto.projectName))]), _vm._v(" "), _vm._l((projeto.children), function(filho) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (projeto.show),
          expression: "projeto.show"
        }],
        staticStyle: {
          "cursor": "pointer"
        }
      }, [_c('li', {
        class: _vm.projetoSelecionado.projectNumber === filho.projectNumber ? 'tree-selected' : '',
        on: {
          "click": function($event) {
            return _vm.selecionaFilho(filho)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-file"
      }), _vm._v("\n        " + _vm._s(filho.projectNumber) + " - " + _vm._s(filho.projectName) + "\n      ")])])
    })], 2)
  }), _vm._v(" "), _c('br')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0874ee25!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/arvoreProjeto.vue
// module id = 1758
// module chunks = 2